export default __webpack_public_path__ + "static/accents-avoid-yellow-dont-light-ac0e0624e61a52cfaa26c79c5eded8cb.png";